import { toFolder } from '../mappers/folder';
import { get } from '../../../utils/utils';
export function parseFolders(res) {
  res.data = get(res, ['data', 'photosets', 'photoset'], []).map(toFolder);
  return res;
}